import gql from 'graphql-tag';

export const CreateInlineTaskNotificationMutation = gql`
	mutation CreateInlineTaskNotification(
		$contentId: ID!
		$tasks: [IndividualInlineTaskNotificationInput]!
	) {
		createInlineTaskNotification(input: { contentId: $contentId, tasks: $tasks }) {
			contentId
			success
			errors {
				message
			}
		}
	}
`;
